import React from "react";
import { scrollToWithBarOffset } from "../../blue-library/utils/scrollToOffset";
export var AnchorLink = function AnchorLink(props) { return /*#__PURE__*/ React.createElement("a", { href: props.to, onClick: function onClick(e) { e.preventDefault(); window.history.replaceState(null, "", props.to); scrollToWithBarOffset(props.to); } }, props.children); };
